import { render, staticRenderFns } from "./VUserPasswordForm.vue?vue&type=template&id=8050494e&"
import script from "./VUserPasswordForm.vue?vue&type=script&lang=js&"
export * from "./VUserPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports